import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FaClose from 'react-icons/lib/fa/close';
import isEqual from 'lodash/isEqual';
import uuid4 from 'uuid/v4';
import ReactModal from 'react-modal';
import ReactResizeDetector from 'react-resize-detector';
import DefaultLayout from './DefaultLayout';
import VideoLayout from './VideoLayout';
import VideoListLayout from './VideoListLayout';


class Modal extends Component {
  constructor (props) {
    super(props);
    this.state = {
      offsetX: '-50%',
      offsetY: '-50%',
      renderKey: uuid4(),
    };
    this.handleContentResize = this.handleContentResize.bind(this);
    this.handleAfterOpen = this.handleAfterOpen.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidUpdate (prevProps, prevState) {
    const { content, children } = this.props;
    if (!isEqual(content, prevProps.content) || !isEqual(children, prevProps.children)) {
      this.setState({ renderKey: uuid4() });
    }
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleContentResize (width, height) {
    // This ensures the css transform doesn't position the element
    // on a fractional pixel, which causes rendering artifacts.
    this.setState({
      offsetX: `-${Math.round(width / 2)}px`,
      offsetY: `-${Math.round(height / 2)}px`,
    });
  }

  handleLayoutUpdate () {
    // TODO: consider updating offsets here to recenter the window,
    // with a transition.
  }

  handleAfterOpen () {
    const { onAfterOpen, onClickOutside } = this.props;
    if (onAfterOpen) {
      onAfterOpen();
    }
    if (onClickOutside) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }

  handleRequestClose () {
    const { onRequestClose } = this.props;
    if (onRequestClose) {
      onRequestClose();
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside (e) {
    const { onClickOutside } = this.props;
    if (onClickOutside && this.contentRef && !this.contentRef.contains(e.target)) {
      onClickOutside(e);
    }
  }

  renderWithChildren () {
    const { title, children } = this.props;
    return [
      <header key="modal-header" className="modal-header">
        <h2 className="heading-display">{title}</h2>
        <div className="modal-close" onClick={this.handleRequestClose}>
          <FaClose />
        </div>
      </header>,
      <div key="modal-content" className="modal-content">
        {children}
      </div>,
    ];
  }

  render () {
    const { title, content, style, children, ...rest } = this.props;
    const { offsetX, offsetY, renderKey } = this.state;
    const classes = {
      base: 'modal',
      afterOpen: 'modal--after-open',
      beforeClose: 'modal--before-close',
    };
    const overlayClasses = {
      base: 'modal-overlay',
      afterOpen: 'modal-overlay--after-open',
      beforeClose: 'modal-overlay--before-close',
    };
    const modalStyles = {
      overlay: style.overlay,
      content: {
        ...style.content,
        transform: `translate3d(${offsetX}, ${offsetY}, 0)`,
      },
    };

    let Layout = DefaultLayout;
    if (content.videos && content.videos.length > 0) {
      Layout = content.videos.length === 1 ? VideoLayout : VideoListLayout;
    }

    return (
      <ReactModal
        key={renderKey}
        className={classes}
        overlayClassName={overlayClasses}
        ariaHideApp={false}
        closeTimeoutMS={200}
        style={modalStyles}
        contentRef={node => this.contentRef = node}
        {...rest}
        onAfterOpen={this.handleAfterOpen}
        onRequestClose={this.handleRequestClose}
      >
        <ReactResizeDetector handleWidth handleHeight onResize={this.handleContentResize}>
          {content ? <Layout {...content} onCloseClick={rest.onRequestClose} onChange={this.handleLayoutUpdate} /> : this.renderWithChildren()}
        </ReactResizeDetector>
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  ...ReactModal.propTypes,
  onClickOutside: PropTypes.func,
};

Modal.defaultProps = {
  style: {
    overlay: {},
    content: {},
  },
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js